import { UserRolesEnum } from '@collections/users/enums';
export type AppPageType = 'news' | 'product' | 'company' | 'event' | 'halls' | 'website';

export class DataLayerCustomDimensions {
  userId: string = undefined;
  userRole1: string = undefined;
  userRole2: string = undefined;
  loginStatus: 'logged_in' | 'logged_out';
  category: string = undefined;
  pageType: AppPageType = undefined;
  authorId: string = undefined;
  companySlug: string = undefined;

  constructor(userId: string, userRoles: string[]) {
    this.userId = userId;
    if (userRoles && userRoles.length > 1) {
      const roles = userRoles.filter(r => r !== UserRolesEnum.basic);
      this.userRole1 = roles[0];
      this.userRole2 = roles[1] ?? undefined;
    } else {
      this.userRole1 = userRoles[0];
    }

    this.loginStatus = userId ? 'logged_in' : 'logged_out';
  }
}
